export var version = '1.8.2';